export const emojis = [
    '😀',
    '😁',
    '😂',
    '😃',
    '😉',
    '😋',
    '😎',
    '😍',
    '😗',
    '🤗',
    '🤔',
    '😣',
    '😫',
    '😴',
    '😌',
    '🤓',
    '😛',
    '😜',
    '😠',
    '😇',
    '😷',
    '😈',
    '👻',
    '😺',
    '😸',
    '😹',
    '😻',
    '😼',
    '😽',
    '🙀',
    '🙈',
    '🙉',
    '🙊',
    '👼',
    '👮',
    '🕵',
    '💂',
    '👳',
    '🎅',
    '👸',
    '👰',
    '👲',
    '🙍',
    '🙇',
    '🚶',
    '🏃',
    '💃',
    '⛷',
    '🏂',
    '🏌',
    '🏄',
    '🚣',
    '🏊',
    '⛹',
    '🏋',
    '🚴',
    '👫',
    '💪',
    '👈',
    '👉',
    '👆',
    '👇',
    '🖖',
    '🤘',
    '🖐',
    '👌',
    '👍',
    '👎',
    '✊',
    '👊',
    '👏',
    '🙌',
    '🙏',
    '🐵',
    '🐶',
    '🐇',
    '🐥',
    '🐸',
    '🐌',
    '🐛',
    '🐜',
    '🐝',
    '🍉',
    '🍄',
    '🍔',
    '🍤',
    '🍨',
    '🍪',
    '🎂',
    '🍰',
    '🍾',
    '🍷',
    '🍸',
    '🍺',
    '🌍',
    '🚑',
    '⏰',
    '🌙',
    '🌝',
    '🌞',
    '⭐',
    '🌟',
    '🌠',
    '🌨',
    '🌩',
    '⛄',
    '🔥',
    '🎄',
    '🎈',
    '🎉',
    '🎊',
    '🎁',
    '🎗',
    '🏀',
    '🏈',
    '🎲',
    '🔇',
    '🔈',
    '📣',
    '🔔',
    '🎵',
    '🎷',
    '💰',
    '🖊',
    '📅',
    '✅',
    '❎',
    '💯',
];